
import React from "react";
import Swal from "sweetalert2";
import CoManaged from '../surgicalComponents/segComanagementAgreement';

const SurgicalSchedulingForm = ({
    SurgeryFormData,
    setSurgeryFormData,
    currentPage,
    setCurrentPage,
    pageRefs,
    pageTitles,
    isNext,
    invalidFields,
    handleInputChange,
    handleCheckboxChange,
    verifyDob,
    setVerifyDob,
    signatures,
    setSignatures,
    isEditing,
    toggleEditMode,
    updateSignatureData,
    clearSignature,
    canvasRefs,
    surgeonOptionsMap,
    docSignature,
    logo,
    renderNextButton,
    renderSurgeryUploadButton,
    surgeryUpload,
    formatDate,
    handleMedicationTimeChange,
    getCentralAmericaDate,
    getCentralAmericaTime,
    handleNext,
    Paragraph,
    Logo,
    Head,
    SignatureField,
    TextInput,
    MedTimePicker,
    TextArea,
    DatePickerInput,
    RadioGroup,
    FormInput,
    SegLogoBanner,
    Initials,
    SegFooter,
    SegFinancialConsent,
    SegAuthorizationForm,
    anesthesiaOptions,
    formattedDate,
    LeftCheckBox,
    handleProcedureChange,
    Scheduling,
    MultiSelector,
    CheckboxField,
    MultiSelectorWithoutEyes,
    MultiFieldSelector,
    handleChange,
    LALConsent,
    SEGMigsConsent,
    CoManagementAgreement,
    SEGGeneralConsent,
    EyeSelector,
    totalPages,
    CataractForm,
    IOLConsent,
    pagesToDisplay,
    handleEyeChange,
    SelectInput,
    surgicalLocation,
    consentNotes
}) => {
    const [showNotesModal, setShowNotesModal] = React.useState(false);

    const commonProps = {
        pageRefs,
        currentPage,
        logo,
        pageTitles,
        SurgeryFormData,
        surgeonOptionsMap,
        docSignature,
        setSignatures,
        setSurgeryFormData,
        handleInputChange,
        invalidFields,
        isNext,
        isEditing,
        signatures,
        canvasRefs,
        updateSignatureData,
        clearSignature,
        toggleEditMode,
        getCentralAmericaDate,
        getCentralAmericaTime,
        Logo,
        Head,
        Paragraph,
        RadioGroup,
        TextInput,
        SignatureField,
        SegLogoBanner,
        Initials,
        surgeryUpload,
        FormInput,
        formattedDate,
        MultiSelector,
        MultiSelectorWithoutEyes,
        handleCheckboxChange,
        SegFooter
    };

    const getEyeForPage = (pageType) => {
        const pageInstances = {};
        pagesToDisplay.forEach((page, idx) => {
            if (idx < pagesToDisplay.indexOf(pageType)) return;
            if (page === pageType) {
                pageInstances[pageType] = (pageInstances[pageType] || 0) + 1;
            }
        });

        const instanceCount = pagesToDisplay.filter((p, idx) => {
            return pagesToDisplay.slice(0, pagesToDisplay.indexOf(pageType)).includes(p);
        }).length;

        if (SurgeryFormData.eye === "ou" && (pageType === "cataract_consent_form" || pageType === "authorization_consent_form")) {
            const currentInstance = pagesToDisplay.slice(0, pagesToDisplay.indexOf(pageType) + 1).filter(p => p === pageType).length;
            return currentInstance === 1 ? "od" : "os";
        }
        return SurgeryFormData.eye;
    };

    const renderPageComponent = (pageType, pageIndex) => {
        const currentInstance = pagesToDisplay.slice(0, pageIndex + 1).filter(p => p === pageType).length;
        const eyeForPage = SurgeryFormData.eye === "ou" && (pageType === "cataract_consent_form" || pageType === "authorization_consent_form" || pageType === "iol_form")
            ? (currentInstance === 1 ? "od" : "os")
            : SurgeryFormData.eye?.toLowerCase();

        switch (pageType) {
            case "general_consent_form":
                return (
                    <SEGGeneralConsent
                        key={pageIndex}
                        {...commonProps}
                        EyeSelector={EyeSelector}
                    />
                );
            case "authorization_consent_form":
                return (
                    <SegAuthorizationForm
                        key={pageIndex}
                        {...commonProps}
                        anesthesiaOptions={anesthesiaOptions}
                        LeftCheckBox={LeftCheckBox}
                        eye={eyeForPage}
                    />
                );
            case "cataract_consent_form":
                return (
                    <CataractForm
                        key={pageIndex}
                        {...commonProps}
                        eye={eyeForPage}
                        CheckboxField={CheckboxField}
                        handleEyeChange={handleEyeChange}
                    />
                );
            case "iol_form":
                return (
                    <IOLConsent
                        key={pageIndex}
                        {...commonProps}
                        eye={eyeForPage}
                    />
                );
            case "migs_form":
                return (
                    <SEGMigsConsent
                        key={pageIndex}
                        {...commonProps}
                    />
                );
            case "lal_form":
                return (
                    <LALConsent
                        key={pageIndex}
                        {...commonProps}
                    />
                );
            case "scheduling_form":
                return (
                    <Scheduling
                        key={pageIndex}
                        {...commonProps}
                        anesthesiaOptions={anesthesiaOptions}
                        LeftCheckBox={LeftCheckBox}
                        MultiSelector={MultiSelector}
                        CheckboxField={CheckboxField}
                        MultiFieldSelector={MultiFieldSelector}
                        handleChange={handleChange}
                    />
                );
            case "financial_consent_form":
                return (
                    <SegFinancialConsent
                        key={pageIndex}
                        {...commonProps}
                        SelectInput={SelectInput}
                        surgicalLocation={surgicalLocation}
                    />
                );
            case "co_management_form":
                return (
                    <CoManaged
                        key={pageIndex}
                        {...commonProps}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            {consentNotes && Object.keys(consentNotes).length > 0 && (
                <div className="flex justify-end mx-5 mb-4 gap-3 flex-wrap">
                    <button
                        type="button"
                        onClick={() => setShowNotesModal(true)}
                        className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 transition-all flex items-center gap-2"
                    >
                        <i className="fas fa-sticky-note"></i>
                        View Notes
                    </button>
                    {SurgeryFormData.cataract_consent_form && (
                        <div className="flex items-center gap-6">

                            <EyeSelector
                                SurgeryFormData={SurgeryFormData}
                                handleInputChange={handleInputChange}
                                showLabel={true}
                            />


                            <div className="flex items-center gap-3">
                                <span className="text-sm font-medium text-gray-700">LAL Form</span>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={SurgeryFormData.lal_form}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            Swal.fire({
                                                title: 'Confirm Change',
                                                text: `Are you sure you want to ${!SurgeryFormData.lal_form ? 'enable' : 'disable'} LAL Form?`,
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Yes, change it!',
                                                cancelButtonText: 'Cancel'
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    setSurgeryFormData((prev) => ({
                                                        ...prev,
                                                        lal_form: !prev.lal_form,
                                                    }));
                                                    Swal.fire({
                                                        title: 'Updated',
                                                        text: `LAL Form has been ${!SurgeryFormData.lal_form ? 'enabled' : 'disabled'}.`,
                                                        icon: 'success',
                                                        timer: 1500
                                                    });
                                                }
                                            });
                                        }}
                                        className="sr-only peer"
                                    />
                                    <div className="w-14 h-8 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-7 after:w-7 after:transition-all peer-checked:bg-blue-600"></div>
                                </label>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="text-sm font-medium text-gray-700">MIGS Form</span>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={SurgeryFormData.migs_form}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            Swal.fire({
                                                title: 'Confirm Change',
                                                text: `Are you sure you want to ${!SurgeryFormData.migs_form ? 'enable' : 'disable'} MIGS Form?`,
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Yes, change it!',
                                                cancelButtonText: 'Cancel'
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    setSurgeryFormData((prev) => ({
                                                        ...prev,
                                                        migs_form: !prev.migs_form,
                                                    }));
                                                    Swal.fire({
                                                        title: 'Updated',
                                                        text: `MIGS Form has been ${!SurgeryFormData.migs_form ? 'enabled' : 'disabled'}.`,
                                                        icon: 'success',
                                                        timer: 1500
                                                    });
                                                }
                                            });
                                        }}
                                        className="sr-only peer"
                                    />
                                    <div className="w-14 h-8 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-7 after:w-7 after:transition-all peer-checked:bg-blue-600"></div>
                                </label>
                            </div>
                            <div className="flex items-center gap-3">
                                <span className="text-sm font-medium text-gray-700">Co-Management Form</span>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={SurgeryFormData.comanaged_by_seg}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            Swal.fire({
                                                title: 'Confirm Change',
                                                text: `Are you sure you want to ${!SurgeryFormData.comanaged_by_seg ? 'enable' : 'disable'} Co-Management Form?`,
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Yes, change it!',
                                                cancelButtonText: 'Cancel'
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    setSurgeryFormData((prev) => ({
                                                        ...prev,
                                                        comanaged_by_seg: !prev.comanaged_by_seg,
                                                    }));
                                                    Swal.fire({
                                                        title: 'Updated',
                                                        text: `Co-Management Form has been ${!SurgeryFormData.co_management_form ? 'enabled' : 'disabled'}.`,
                                                        icon: 'success',
                                                        timer: 1500
                                                    });
                                                }
                                            });
                                        }}
                                        className="sr-only peer"
                                    />
                                    <div className="w-14 h-8 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-7 after:w-7 after:transition-all peer-checked:bg-blue-600"></div>
                                </label>
                            </div>
                        </div>
                    )}
                    {(!SurgeryFormData.cataract_consent_form && !SurgeryFormData.general_consent_form) && (
                        <div className="flex items-center gap-6">
                            <div className="flex items-center gap-3">
                                <span className="text-sm font-medium text-gray-700">MIGS Form</span>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={SurgeryFormData.migs_form}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            Swal.fire({
                                                title: 'Confirm Change',
                                                text: `Are you sure you want to ${!SurgeryFormData.migs_form ? 'enable' : 'disable'} MIGS Form?`,
                                                icon: 'question',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Yes, change it!',
                                                cancelButtonText: 'Cancel'
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    setSurgeryFormData((prev) => ({
                                                        ...prev,
                                                        migs_form: !prev.migs_form,
                                                    }));
                                                    setCurrentPage(0);
                                                    Swal.fire({
                                                        title: 'Updated',
                                                        text: `MIGS Form has been ${!SurgeryFormData.migs_form ? 'enabled' : 'disabled'}.`,
                                                        icon: 'success',
                                                        timer: 1500
                                                    });
                                                }
                                            });
                                        }}
                                        className="sr-only peer"
                                    />
                                    <div className="w-14 h-8 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-7 after:w-7 after:transition-all peer-checked:bg-blue-600"></div>
                                </label>
                            </div>
                        </div>
                    )}
                </div>
            )}

            <form className="bg-white">

                {renderPageComponent(pagesToDisplay[currentPage], currentPage)}

                {/* Footer Buttons */}
                <div className="flex justify-end mx-5">
                    <div className="flex space-x-4">
                        {currentPage < totalPages - 1
                            ? renderNextButton()
                            : renderSurgeryUploadButton()}
                    </div>

                </div>

            </form>

            {/* Notes Modal */}
            {showNotesModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-96 overflow-auto">
                        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
                            <h3 className="text-lg font-semibold text-gray-900">Consent Notes</h3>
                            <button
                                type="button"
                                onClick={() => setShowNotesModal(false)}
                                className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                            >
                                ×
                            </button>
                        </div>
                        <div className="p-6 space-y-3">
                            {Object.entries(consentNotes).map(([key, value]) => (
                                <div key={key} className="border-b last:border-b-0 pb-3 last:pb-0">
                                    <p className="text-sm font-medium text-gray-700 mb-1">{key}:</p>
                                    <p className="text-sm text-gray-600">{String(value)}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SurgicalSchedulingForm;
